// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"811b7335","453":"99a08677","732":"e2d5ccd6"}[chunkId] + ".chunk.js";
};